module.exports = __webpack_public_path__ + "static/img/guanbihuiyi.b49818f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/guanbihuiyi.png
// module id = rj7i
// module chunks = 24